import BaseRightContent from "../BaseHistoricTimeSpaceChart/BaseRightContent";

class RightContent extends BaseRightContent {
  constructor(props) {
    super(props);
  }
}

export default RightContent;
